export default "__VITE_ASSET__BW_hA7W2__"